var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleplateau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 35H49",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 40.6852V41H11.1171H11.3175L11.396 40.8084L13.7151 35.1442L13.7161 35.1417L17.1989 26.8333H20.6389L23.6873 35.1308L23.7617 35.3333H23.9704H26.5533H27L26.8349 34.9022L22.7367 24.1985L22.6607 24H22.4552H15.1821H14.9808L14.9028 24.1929L10.5734 34.8946L10.5726 34.8966L9.22445 38.1667H7.30304V38.4815L7 40.6852Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0746 41H25.9249L25.8664 40.8174L24.1339 35.4174L24 35H24.3421H26.2726H26.4218L26.4806 35.1819L27.4879 38.3H28.5266H30V38.6V40.7V41H28.7666H26.0746Z",
    fill: "#E94C69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5252 41H10.7037L10.7736 40.8174L12.8403 35.4174L13 35H12.5919H10.289H10.1109L10.0409 35.1819L8.83928 38.3H7.60017H7.36808L7.33326 38.5551L7.04702 40.6551L7 41H7.31388H10.5252Z",
    fill: "#E94C69",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51 40.6852V41H46.8829H46.6825L46.604 40.8084L44.2849 35.1442L44.2839 35.1417L40.8011 26.8333H37.3611L34.3127 35.1308L34.2383 35.3333H34.0296H31.4467H31L31.1651 34.9022L35.2633 24.1985L35.3393 24H35.5448H42.8179H43.0192L43.0972 24.1929L47.4266 34.8946L47.4274 34.8966L48.7755 38.1667H50.697V38.4815L51 40.6852Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9254 41H32.0751L32.1336 40.8174L33.8661 35.4174L34 35H33.6579H31.7274H31.5782L31.5194 35.1819L30.5121 38.3H28V40.7V41H29.2334H31.9254Z",
    fill: "#E94C69"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4748 41H47.2963L47.2264 40.8174L45.1597 35.4174L45 35H45.4081H47.711H47.8891L47.9591 35.1819L49.1607 38.3H50.3998H50.6319L50.6667 38.5551L50.953 40.6551L51 41H50.6861H47.4748Z",
    fill: "#E94C69",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleplateau);
export default __webpack_public_path__ + "static/media/double plateau.406bdcc853524fd9ec56be122e9fd91d.svg";
export { ForwardRef as ReactComponent };